module.exports = __webpack_public_path__ + "static/media/sign-up-background.0d3bdf53.png";